/**
 * @author Eric Otto
 */

module.exports = {
    filterForm: document.querySelector('#load-filter'),

    groupCategory: document.querySelector('.group-category'),
    groupCustomer: document.querySelector('.group-customer'),

    init: function ($container) {
        'use strict';

        this.filterForm = $container
            ? $container.querySelector('#load-filter')
            : document.querySelector('#load-filter');

        if (!this.filterForm) {
            return;
        }

        this.groupCategory = this.filterForm.querySelector('.group-category');
        this.groupCustomer = this.filterForm.querySelector('.group-customer');


        const that = this,
            container = document.getElementById('load-more-content'),
            retinaImages = require('./retinaImages'),
            ajaxLoad = require('./ajaxLoad'),
            loadMore = require('./loadMore'),
            r = new XMLHttpRequest();

        r.onreadystatechange = function () {
            if (r.readyState !== 4 || r.status !== 200) {
                return;
            }
            container.innerHTML = r.responseText;
            retinaImages.init(container);
            ajaxLoad.init(container);
            loadMore.resetCounter();
            that.showElements(container);
        };

        this.filterForm.addEventListener('change', function (event) {
            if (!event.target.classList.contains('filter')) {
                return;
            }

            const activeFilter = that.filterForm.querySelectorAll('input.filter:checked'),
                activeLabel = that.filterForm.querySelector('input:not(.filter):checked');

            if(activeFilter.length) {
                that.filterForm.classList.add('active');

                if (that.filterForm.querySelector('input.filter:checked[data-group="customer"]')) {
                    that.groupCustomer.classList.add('active');
                } else {
                    that.groupCustomer.classList.remove('active');
                }

                if (that.filterForm.querySelector('input.filter:checked[data-group="category"]')) {
                    that.groupCategory.classList.add('active');
                } else {
                    that.groupCategory.classList.remove('active');
                }

            } else {
                that.filterForm.classList.remove('active');
                that.groupCategory.classList.remove('active');
                that.groupCustomer.classList.remove('active');
            }

            activeLabel.click();

            const formData = that.getFormData();

            r.open('POST', that.filterForm.getAttribute('data-uri'), true);
            r.send(formData);
        });
    },

    getFormData: function () {
        'use strict';

        if (this.filterForm) {
            return new FormData(this.filterForm);
        }

        return false;
    },

    showElements: function (container) {
        const elements = container.querySelectorAll('div');
        let intTime = 0;

        for (let i = 0; i < elements.length; i++) {
            window.setTimeout(function () {
                if (elements[i].classList.contains('is-paused')) {
                    elements[i].classList.remove('is-paused');
                }
            }, intTime);
            intTime += 250;
        }
    }
};
